import React from 'react';
import proptypes from 'prop-types';
import { useConfigService } from '@thd-nucleus/experience-context';
const { bool } = proptypes;
import { Button } from '@one-thd/sui-atomic-components';
import { useSpecialBuy } from '../../context/SpecialBuyProvider';
import { FEATURE_SWITCH_KEYS } from '../../constants';

const SpecialBuyNavButton = ({ isFullWidth }) => {
  const { specialBuyType, isFallbackBanner, specialBuyEndpoint } = useSpecialBuy();
  const isDailyDealsEnabled = useConfigService(FEATURE_SWITCH_KEYS.isDailyDealsEnabled);

  return (
    <div>
      <Button
        variant="primary"
        href={specialBuyEndpoint}
        fullWidth={isFullWidth}
      >
        {isFallbackBanner && <>Shop&nbsp;All&nbsp;Savings</>}
        {!isFallbackBanner && (
          <>
            {(specialBuyType === 'sbotd' && isDailyDealsEnabled) && <>Shop&nbsp;Daily&nbsp;Deals</>}
            {(specialBuyType === 'sbotd' && !isDailyDealsEnabled) && <>Shop&nbsp;Today&apos;s&nbsp;Specials</>}
            {(specialBuyType === 'pro') && <>Shop&nbsp;Pro&nbsp;Specials</>}
          </>
        )}
      </Button>
    </div>
  );
};

SpecialBuyNavButton.displayName = 'SpecialBuyNavButton';

SpecialBuyNavButton.propTypes = {
  isFullWidth: bool,
};

SpecialBuyNavButton.defaultProps = {
  isFullWidth: false,
};

export { SpecialBuyNavButton };
